module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB2002-10903a97d7006881d25f536a45beda42.png";